// Shared by the desktop sidebar rail and components positioned beside it.
export const SIDEBAR_RAIL_WIDTH = '5.625rem';
